import Vue from 'vue'
import Spinner from './Spinner'

const elems = document.getElementsByTagName('spinner')

for (let i = elems.length - 1; i >= 0; --i) {
  const elem = elems[i]
  new Vue( Spinner ).$mount( elem )
}
